import VueToast from 'vue-toast-notification';
import Vue from 'vue';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);